import { useStyles } from "@/styles/useStyles";

export function AssignmentStepNumber({ stepNumber }: { stepNumber: number }) {
    const { theme } = useStyles();
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          height: 24,
          width: 24,
          backgroundColor: theme.colors.primary[8],
          color: theme.colors.primary[0],
          fontSize: 14,
          fontWeight: 700,
          marginRight: 4,
        }}
      >
        {stepNumber}
      </span>
    );
  }
  